import { TimeManagementFilters, TimeManagementListItem } from "@myapp/contract";
import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { timeEntryKeys } from "../time-entry.keys";
import { timeEntryApi } from "../service";

export function useTimeManagementInfiniteQuery(filters: TimeManagementFilters) {
  return useInfinitePaginated<TimeManagementFilters, TimeManagementListItem>({
    queryKey: timeEntryKeys.list(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      timeEntryApi.searchTimeManagement({ ...rest, page }).then((response) => response.data),
    retry: false,
  });
}
